import React from 'react';
import '../styles/HomePage.css';

function PrivacyPolicy(){

  return(

    <div className="homepage-container">

      <section className="workforce-hero fade-in">

        <div className="hero-content">

          <p className="eyebrow">
            AXU Workforce
          </p>

          <h1>
            Privacy Policy
          </h1>

          <p>
            Your privacy is important to us. This policy explains how
            AXU Workforce collects, stores and uses your personal
            information.
          </p>

        </div>

      </section>

      <section className="content-section fade-in">

        <div className="feature-card">

          <h3>Information We Collect</h3>

          <p>

            We may collect:

          </p>

          <ul>

            <li>Name</li>

            <li>Email Address</li>

            <li>Telephone Number</li>

            <li>Home Address</li>

            <li>Date of Birth</li>

            <li>National Insurance Number</li>

            <li>Employment History</li>

            <li>Qualifications</li>

            <li>Emergency Contact Details</li>

            <li>Payroll Information</li>

            <li>Uploaded Identity Documents</li>

          </ul>

        </div>

      </section>

      <section className="content-section fade-in">

        <div className="feature-card">

          <h3>How We Use Your Information</h3>

          <ul>

            <li>Process worker applications.</li>

            <li>Match workers with employers.</li>

            <li>Verify identity and Right to Work.</li>

            <li>Communicate job opportunities.</li>

            <li>Manage payroll and recruitment.</li>

            <li>Comply with legal obligations.</li>

          </ul>

        </div>

      </section>

      <section className="content-section fade-in">

        <div className="feature-card">

          <h3>Data Security</h3>

          <p>

            Your information is stored securely using trusted cloud
            providers including Firebase and related services. We take
            reasonable technical and organisational measures to protect
            your personal information from unauthorised access,
            disclosure or loss.

          </p>

        </div>

      </section>

      <section className="content-section fade-in">

        <div className="feature-card">

          <h3>Your Rights</h3>

          <ul>

            <li>Request a copy of your personal information.</li>

            <li>Request corrections to inaccurate information.</li>

            <li>Request deletion where legally permitted.</li>

            <li>Withdraw consent where applicable.</li>

          </ul>

        </div>

      </section>

      <section className="content-section fade-in">

        <div className="feature-card">

          <h3>Contact Us</h3>

          <p>

            For any privacy related enquiries please contact:

          </p>

          <p>

            info@axuworkforce.co.uk

          </p>

        </div>

      </section>

    </div>

  );

}

export default PrivacyPolicy;